<script setup lang="ts">
import { Logo } from "@/shared/components/temparary/components";
</script>

<template>
    <section class="relative flex items-center justify-center w-full overflow-hidden h-lvh">
        <!-- 배경 그라데이션 -->
        <div
            class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[500px]"
        >
            <div class="gradient-blob"></div>
        </div>
        <div class="absolute inset-0">
            <div
                class="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:50px_50px]"
            ></div>
        </div>
        <!-- 메인 콘텐츠 -->
        <div
            class="relative flex flex-col justify-center items-center w-full max-w-[640px] mx-auto px-6"
        >
            <div class="w-[15.8rem] h-[4.5rem] mb-8">
                <Logo class="w-[15.8rem] h-[4.5rem]" />
            </div>
            <div class="w-full p-8 shadow-lg bg-white/90 backdrop-blur-md rounded-xl">
                <header class="flex flex-col justify-center items-center gap-[2rem] mb-8">
                    <h1 class="text-[2.4rem] font-bold font-pretended">로그인</h1>
                    <p class="text-[1.6rem] text-center font-medium text-t-basic font-pretended">
                        수심달 학원 관리자 페이지에 오신 것을 환영합니다.
                    </p>
                </header>
                <slot></slot>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.gradient-blob {
    position: absolute;
    width: 100%;
    height: 100%;
    filter: blur(50px);
    animation: rotate 20s linear infinite;
    background: linear-gradient(
        to right,
        #ff8a80 0%,
        #ff5252 25%,
        #40c4ff 50%,
        #ff8a80 75%,
        #ff5252 100%
    );
    background-size: 200% auto;
    animation: gradient 10s linear infinite;
    opacity: 0.15;
}

@keyframes gradient {
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
}

@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
